import styled from 'styled-components';

export const StyledModalContent = styled.div`
    & nab-idp-password, & nab-idp-usernamepassword-tokencode {
        margin: calc(-2.5rem - 2px);
        border-radius: 8px;
        overflow: hidden;
        display: block;
    }
`;
